let request = null;
let filter = defaultFilter();

function ajax() {
  const feed = $(".feed");

  //   if (feed.length) {
  //     feed.html("");
  //     runAjax(0, feed.data("type"), parseInt(feed.data("ppp")));
  //   }

  $(".clear-filter").on("click", function () {
    $(".filter-dropdown").hide();
    $(this).parent().parent().parent().removeClass("z-50");
    $(".toggle-filter svg").removeClass("transform rotate-180");

    $(this)
      .parent()
      .parent()
      .find('input[type="checkbox"]')
      .each(function () {
        $(this).prop("checked", false);
      });

    if ($(this).parent().parent().find("#from-value").length) {
      $("#from-value").val("");
      $("#to-value").val("");
    }

    $(this).parent().parent().parent().find("span.amount").text("");

    setFilter();

    runAjax(
      0,
      feed.data("type"),
      parseInt(feed.data("ppp")),
      true,
      feed.data("relation")
    );
  });

  $(".apply-filter").on("click", function () {
    $(".filter-dropdown").hide();
    $(this).parent().parent().parent().removeClass("z-50");
    $(".toggle-filter svg").removeClass("transform rotate-180");

    setFilter();

    if ($(this).hasClass("apply-date")) {
      if ($("#from-value").val() === "" && $("#to-value").val() === "") {
        $(".toggle-date span").text("Datum");
      } else if ($("#to-value").val() === "") {
        $(".toggle-date span").text($("#from-value").val());
      } else {
        $(".toggle-date span").text(
          $("#from-value").val() + " - " + $("#to-value").val()
        );
      }
    } else {
      const checked = $(this).parent().parent().parent().find("input:checked");

      if (checked.length) {
        $(this)
          .parent()
          .parent()
          .parent()
          .find("span.amount")
          .text(checked.length)
          .addClass("inline-block")
          .removeClass("hidden");
      } else {
        $(this)
          .parent()
          .parent()
          .parent()
          .find("span.amount")
          .text("")
          .removeClass("inline-block")
          .addClass("hidden");
      }
    }

    if (
      $("body").hasClass("page-template-archive-event-template") ||
      $("body").hasClass("page-template-archive-artist-template") ||
      $("body").hasClass("page-template-archive-show-template") ||
      $("body").hasClass("page-template-archive-news-template") ||
      $("body").hasClass("single-show")
    ) {
      runAjax(
        0,
        feed.data("type"),
        parseInt(feed.data("ppp")),
        true,
        feed.data("relation")
      );
    } else {
      let params = {};

      if (filter.city.length) {
        params.stader = filter.city.join(",");
      }

      if (filter.genre.length) {
        params.genrer = filter.genre.join(",");
      }

      if (filter.artists.length) {
        params.artister = filter.artists.join(",");
      }

      if (filter.from) {
        params.f = filter.from;
      }

      if (filter.to) {
        params.t = filter.to;
      }

      var url = "/biljetter/?" + $.param(params);

      window.location.href = url;
    }
  });

  $("#load-more").on("click", function (e) {
    e.preventDefault();

    let offset = parseInt($(this).data("offset"));
    let type = $(this).data("type");
    let ppp = parseInt($(this).data("ppp"));

    runAjax(offset, type, ppp);
  });
}

function defaultFilter() {
  return {
    city: [],
    genre: [],
    artists: [],
    from: false,
    to: false,
  };
}

function setFilter() {
  filter = defaultFilter();

  $('input[name="filter-city"]:checked').each(function () {
    filter.city.push(parseInt($(this).val()));
  });

  $('input[name="filter-artist"]:checked').each(function () {
    filter.artists.push(parseInt($(this).val()));
  });

  $('input[name="filter-genre"]:checked').each(function () {
    filter.genre.push(parseInt($(this).val()));
  });

  if ($("#from-value").val() != "") {
    filter.from = $("#from-value").val();
  }

  if ($("#to-value").val() != "") {
    filter.to = $("#to-value").val();
  }
}

function runAjax(
  offset = 0,
  type = "event",
  ppp = 20,
  reset = false,
  relation = false
) {
  if (request != null) {
    request.abort();
  }
  request = $.ajax({
    type: "GET",
    data: {
      offset,
      type,
      ppp,
      filter,
      relation,
    },
    dataType: "html",
    url: oake.load_more,
    beforeSend: function beforeSend() {
      if (reset) {
        $(".feed").html("");
      }
      $("#load-more").addClass("loading");
    },
    success: function success(data) {
      if (data != "empty") {
        $(".feed").append(data);
        request = null;
        $("#load-more").removeClass("loading");
        $("#load-more").data("offset", offset + ppp);
      } else {
        if ($(".feed").html() == "") {
          $(".feed").html(
            "<div class='pt-10 px-5'>Det finns tyvärr inget resultat med de filter du angivit. Vänligen prova en annan kombination.</div>"
          );
        }
        $("#load-more").hide();
      }
    },
  });
}

export default ajax;
